import Translator from '../core/i18n';
import { IAuthInformation } from '../models/action/core';
import { SecurityContextType, SecurityPermissionType } from './SecurityContext';
import { Log } from 'ng2-logger';
import { UserType } from '../models/pages/login.d';
import SecurityContext from '../core/SecurityContext';
import { IStringFormat, ISelect } from '../models/core/system-model';
import { IPreference } from '../models/action/profile';
import Moment from 'moment';
import { ActivityType, ActivityTypeEnums } from '../models/enums/ActivityType';
import { DateCriteria } from '../models/enums/dateCriteria';
import ICourseContentTermWeeks from '../models/components/course-content-termweeks';
import { VideoType } from '../models/enums/VideoType';
import queryString from 'querystring';
import * as types from '../models/action/userHome';
import { URLSearchParams } from 'url';
import LanguageDetect from 'languagedetect';
import ApiClient from '../api/alms-api';

const T = Translator.create();
const _logger = Log.create('common.ts');
const _fullPermissionMap = SecurityContext.create();
const lngDetector = new LanguageDetect();
//let _apiClient: ApiClient = new ApiClient();
export class Common {
    public static HasPermission(contextType: SecurityContextType, permissionType: SecurityPermissionType, contextId: string): boolean {
        const main = JSON.parse(localStorage.getItem('persist:almsPlusPersist')!);
        if (main) {

            const innerLogin = JSON.parse(main.login);
            const { loginPermission, customLoginPermission, userType } = innerLogin.identitiy;

            // const checkContextId = _apiClient.RequestAsync('POST', 'api/address')
            //     .then(responseData => {
            //         if (responseData && responseData.status === 200) {
            //             console.log('checkContextId success');
            //         }
            //     })
            //     .catch(() => {
            //         console.log('checkContextId error');
            //     });


            if (customLoginPermission && customLoginPermission.length > 0) {
                const deniedPermissions = customLoginPermission.filter((data: any) => data.securityPermission === permissionType && !data.granted);
                if (deniedPermissions.length > 0) {
                    return false;
                }
            }

            if (userType === UserType.Admin && permissionType !== SecurityPermissionType.Core_CockpitView) {
                return true;
            }

            const authList = _fullPermissionMap.PermissionMapList.filter(
                f => f.securityContextType === contextType && f.permissionType === permissionType && f.userType === userType
            );

            if (authList.length > 0) {
                return true;
            }

            if (loginPermission) {
                const isProgramAdmin = (role: any) => role === UserType.ProgramAdmin;
                const hasPermission = (data: any) => data.contextId === contextId && data.contextType === contextType;

                if (permissionType === SecurityPermissionType.Core_CockpitView && loginPermission.some(isProgramAdmin)) {
                    return true;
                }

                if (contextType === SecurityContextType.Course && permissionType === SecurityPermissionType.Activity_Add && loginPermission.some(isProgramAdmin)) {
                    return true;
                }

                if (loginPermission.some(hasPermission) && authList.length > 0) {
                    return true;
                }

                if (loginPermission.some((data: any) => data.contextId === contextId && data.contextType === SecurityContextType.Course) && authList.length > 0) {
                    return true;
                }
            }
        }
        return false;
    }

    public readonly QuestionTypesIcons: any = {
        grouping: require('../static/images/openended.svg'),
        multiplesingle: require('../static/images/multiplesingle.svg'),
        matching: require('../static/images/matching.svg'),
        openended: require('../static/images/openended.svg'),
        multiplemultiple: require('../static/images/multiplemultiple.svg'),
        ordering: require('../static/images/ordering.svg'),
        default: require('../static/images/ordering.svg')
    };
    public readonly ActivityIcons: any = {
        text: require('../static/images/text.svg'),
        video: require('../static/images/play.svg'),
        picture: require('../static/images/photo-icon.svg'),
        question: require('../static/images/question-icon.svg'),
        assignment: require('../static/images/detail.svg'),
        reading: require('../static/images/book.svg'),
        discussion: require('../static/images/text.svg'),
        survey: require('../static/images/question-icon.svg'),
        default: require('../static/images/book.svg')
    };
    public readonly FlagIcons: any = {
        english: require('../static/images/flags/gb.svg'),
        arabic: require('../static/images/flags/sa.svg'),
        turkish: require('../static/images/flags/tr.svg'),
    };
    public readonly ActivityTypeIcons: any = {
        document: require('../static/images/defaultIcons/documentactivity/icon.svg'),
        video: require('../static/images/defaultIcons/videoactivity/icon.svg'),
        survey: require('../static/images/defaultIcons/surveyactivity/icon.svg'),
        elesson: require('../static/images/defaultIcons/elessonactivity/icon.svg'),
        exam: require('../static/images/defaultIcons/examactivity/icon.svg'),
        assignment: require('../static/images/defaultIcons/homeworkactivity/icon.svg'),
        forum: require('../static/images/defaultIcons/forumactivity/icon.svg'),
        homework: require('../static/images/defaultIcons/homeworkactivity/icon.svg'),
        linkactivity: require('../static/images/defaultIcons/linkactivity/icon.svg'),
        ltiactivity: require('../static/images/defaultIcons/ltiactivity/icon.svg'),
        link: require('../static/images/defaultIcons/linkactivity/icon.svg'),
        lti: require('../static/images/defaultIcons/ltiactivity/icon.svg'),
        virtualclass: require('../static/images/defaultIcons/virtualclassactivity/icon.svg'),
        project: require('../static/images/defaultIcons/virtualclassactivity/icon.svg'),
        informationnote: require('../static/images/defaultIcons/informationnoteactivity/icon.svg'),
        default: require('../static/images/defaultIcons/defaultactivty/icon.svg'),
        other: require('../static/images/defaultIcons/defaultactivty/icon.svg')
    };

    public readonly MaterialActivityIcons: any = {
        assignment: 'assignment',
        document: 'file_copy',
        project: 'class',
        forum: 'forum',
        video: 'ondemand_video',
        virtualclass: 'dvr',
        link: 'link',
        ltiactivity: 'share',
        default: 'assignment'
    };

    public readonly DefaultImages: any = {
        _assigment: require('../static/images/defaultImages/assigmentCard/assignment.jpg'),
        _document: require('../static/images/defaultImages/documentCard/document.jpg'),
        _link: require('../static/images/defaultImages/linkCard/link.jpg'),
        _poll: require('../static/images/defaultImages/surveyCard/poll.jpg'),
        _virtualclass: require('../static/images/defaultImages/virtualClassCard/virtualclass.png'),
        _forum: require('../static/images/defaultImages/forumCard/forum.jpg'),
        _elesson: require('../static/images/defaultImages/eLessonCard/eLesson.jpg'),
        _morpa: require('../static/images/defaultImages/morpaCard/morpa.jpg'),
        _dersdeo: require('../static/images/defaultImages/dersDeoCard/dersDeo.jpg'),
        _exam: require('../static/images/defaultImages/examCard/exam.jpg'),
        _video: require('../static/images/defaultImages/videoCard/video.jpg'),
        _lti: require('../static/images/defaultImages/ltiCard/lti.jpg'),
        _dictionary: require('../static/images/defaultImages/dictionaryCard/dictionary.jpg'),
        _course: require('../static/images/defaultImages/course/course.jpg'),
        _coursecard: require('../static/images/defaultImages/courseCard/coursecard.jpg'),
        _general: require('../static/images/defaultImages/general.jpg'),
        _activitiesnotfound: require('../static/images/defaultImages/activitiesNotFound/image.png'),
        _nonotification: require('../static/images/defaultImages/notifications/no_notification.png'),
        _avatar: require('../static/images/avatar.png'),
        _not_found: require('../static/images/not_found.svg'),
        _assigment_text: require('../static/images/defaultImages/assigmentCard/text_assignment.png'),
        _assigment_upload: require('../static/images/defaultImages/assigmentCard/upload_assignment.png'),
        _role_not_found: require('../static/images/role_not_found.svg'),
        _dots: require('../static/images/dots.svg'),

    };

    public readonly DefaultIcons: any = {
        addannouncement: require('../static/images/defaultIcons/addAnnouncement/icon.svg'),
        clock: require('../static/images/defaultIcons/clock/icon.svg'),
        dots: require('../static/images/defaultIcons/dots/icon.svg'),
        dotsvertical: require('../static/images/defaultIcons/dotsvertical/icon.svg'),
        share: require('../static/images/defaultIcons/share/icon.png'),
        text: require('../static/images/defaultIcons/text/icon.svg'),
        week: require('../static/images/defaultIcons/week/icon.svg'),
        detail: require('../static/images/defaultIcons/detail/icon.svg'),
        play: require('../static/images/defaultIcons/play/icon.svg'),
        code: require('../static/images/defaultIcons/code/icon.svg'),
        book: require('../static/images/defaultIcons/book/icon.svg'),
        dotsline: require('../static/images/defaultIcons/dotsLine/icon.svg'),
        hamburger: require('../static/images/defaultIcons/hamburger/icon.svg'),
        twitter: require('../static/images/defaultIcons/twitter/icon.svg'),
        facebook: require('../static/images/defaultIcons/facebook/icon.svg'),
        google: require('../static/images/defaultIcons/google/icon.svg'),
        linkedin: require('../static/images/defaultIcons/linkedin/icon.svg'),
        new: require('../static/images/defaultIcons/new/icon.svg'),
        done: require('../static/images/defaultIcons/done/icon.svg'),
        timeblue: require('../static/images/defaultIcons/timeblue/icon.svg'),
        notpurple: require('../static/images/defaultIcons/notpurple/icon.svg'),
        houryellow: require('../static/images/defaultIcons/houryellow/icon.svg'),
        hourred: require('../static/images/defaultIcons/hourred/icon.svg'),
        infoicon: require('../static/images/defaultIcons/infoicon/icon.svg'),
        aplus: require('../static/images/defaultIcons/aplus/icon.svg'),
        blueattach: require('../static/images/defaultIcons/blueattach/icon.svg'),
        homework: require('../static/images/defaultIcons/homework/icon.svg'),
        videolinkphoto: require('../static/images/defaultIcons/videolinkphoto/new-icon.svg'),
        videolink: require('../static/images/defaultIcons/videolinkphoto/link.svg'),
        vimeo: require('../static/images/defaultIcons/vimeo/icon.png'),
        forumIcon: require('../static/images/defaultIcons/forumIcon/icon.svg'),
        timeclock: require('../static/images/defaultIcons/timeclock/icon.svg'),
        sort: require('../static/images/defaultIcons/sort/icon.svg'),
        sortpasif: require('../static/images/defaultIcons/sortpasif/icon.svg'),
        cloud: require('../static/images/defaultIcons/cloud/icon.svg'),
        header: require('../static/images/defaultIcons/survey/header.svg'),
        matris: require('../static/images/defaultIcons/survey/matris.svg'),
        paragraph: require('../static/images/defaultIcons/survey/paragraph.svg'),
        singlechoice: require('../static/images/defaultIcons/survey/singlechoice.svg'),
        multichoice: require('../static/images/defaultIcons/survey/multichoice.svg'),
        feedback: require('../static/images/defaultIcons/feedback/icon.png'),
        filledperson: require('../static/images/defaultIcons/filledperson/icon.svg'),
        filledeye: require('../static/images/defaultIcons/filledeye/icon.svg'),
        filleddoc: require('../static/images/defaultIcons/filleddoc/icon.svg'),
        filleddownload: require('../static/images/defaultIcons/filleddownload/icon.svg'),
        filledupload: require('../static/images/defaultIcons/filledupload/icon.svg'),
        fillednote: require('../static/images/defaultIcons/fillednote/icon.svg'),
        filledback: require('../static/images/defaultIcons/filledback/icon.svg'),
        filledask: require('../static/images/defaultIcons/filledask/icon.svg'),
        filleddiscoss: require('../static/images/defaultIcons/filleddiscoss/icon.svg'),
        filledtime: require('../static/images/defaultIcons/filledtime/icon.svg'),
        fillednone: require('../static/images/defaultIcons/fillednone/icon.svg'),
        filledvideo: require('../static/images/defaultIcons/filledvideo/icon.svg'),
        questionmark: require('../static/images/defaultIcons/questionmark/icon.svg'),
        fillerpersonlight: require('../static/images/defaultIcons/fillerpersonlight/icon.svg'),
        hourstartlight: require('../static/images/defaultIcons/hourstartlight/icon.svg'),
        hoursendlight: require('../static/images/defaultIcons/hoursendlight/icon.svg'),
        refresh: require('../static/images/defaultIcons/refresh/icon.png'),
        movement: require('../static/images/defaultIcons/movement/icon.svg'),
        chevronup: require('../static/images/defaultIcons/chevronup/icon.svg'),
        chevrondown: require('../static/images/defaultIcons/chevrondown/icon.svg'),
        messageoutline: require('../static/images/defaultIcons/messageoutline/icon.svg'),
        user: require('../static/images/defaultIcons/user.svg'),
        displaygrid: require('../static/images/defaultIcons/displaygrid/icon.svg'),
        displaylist: require('../static/images/defaultIcons/displaylist/icon.svg'),
        info: require('../static/images/defaultIcons/info/icon.svg'),
        yellowstar: require('../static/images/defaultIcons/yellowStar/icon.svg'),
        failed: require('../static/images/defaultIcons/activityEnrollment/failed/icon.svg'),
        notstarted: require('../static/images/defaultIcons/activityEnrollment/notstarted/icon.svg'),
        continue: require('../static/images/defaultIcons/activityEnrollment/continue/icon.svg'),
        pinned: require('../static/images/defaultIcons/pinned/icon.svg'),
        back: require('../static/images/defaultIcons/back/icon.svg'),
        headerinbox: require('../static/images/header-inbox.svg'),
        headernotification: require('../static/images/header-notification.svg'),
        headerinboxdark: require('../static/images/header-inbox-dark.svg'),
        headernotificationdark: require('../static/images/header-notification-dark.svg'),
        logout: require('../static/images/defaultIcons/logout/icon.svg'),
        visualapp: require('../static/images/defaultIcons/visualapp/icon.svg'),
        visuallock: require('../static/images/defaultIcons/visuallock/icon.svg'),
        settinglesson: require('../static/images/defaultIcons/settingLesson/icon.svg'),
        settingexam: require('../static/images/defaultIcons/settingExam/icon.svg'),
        settingactivity: require('../static/images/defaultIcons/settingActivity/icon.svg'),
        settingemail: require('../static/images/defaultIcons/settingEmail/icon.svg'),
        settingsms: require('../static/images/defaultIcons/settingSms/icon.svg'),
        settingapp: require('../static/images/defaultIcons/settingApp/icon.svg'),
        settinglogin: require('../static/images/defaultIcons/settingLogin/icon.svg'),
        settingpass: require('../static/images/defaultIcons/settingPassword/icon.svg'),
        settingcheckcopy: require('../static/images/defaultIcons/settingCheckCopy/icon.svg'),
        settingexternalexam: require('../static/images/defaultIcons/settingExternalExam/icon.svg'),
        settingexternalserver: require('../static/images/defaultIcons/settingExternalServer/icon.svg'),
        settingfileuploader: require('../static/images/defaultIcons/settingFileUploader/icon.svg'),
        settinglti: require('../static/images/defaultIcons/settingLti/icon.svg'),
        settingvirtualclass: require('../static/images/defaultIcons/settingVirtualClass/icon.svg'),
        settingwebapi: require('../static/images/defaultIcons/settingWebApi/icon.svg'),
        datestart: require('../static/images/defaultIcons/dateStart/icon.svg'),
        dateend: require('../static/images/defaultIcons/dateEnd/icon.svg'),
        hourglass: require('../static/images/defaultIcons/hourGlass/icon.svg'),
        program: require('../static/images/program.svg'),
        education_module: require('../static/images/coloricons/education_module.svg'),
        cominication_module: require('../static/images/coloricons/cominication_module.svg'),
        notification_module: require('../static/images/coloricons/notification_module.svg'),
        admin_module: require('../static/images/coloricons/admin_module.svg'),
        stats_module: require('../static/images/coloricons/stats_module.svg'),
        report_module: require('../static/images/coloricons/report_module.svg'),
        profile_module: require('../static/images/coloricons/profile_module.svg'),
        star_icon: require('../static/images/star_icon.svg'),
        star_full_icon: require('../static/images/star_full_icon.svg'),
        forum_icon: require('../static/images/forum_icon.svg'),
        clock_icon: require('../static/images/clock_icon.svg'),
        warning_icon: require('../static/images/warning_icon.svg'),
        greendone: require('../static/images/defaultIcons/greendone/icon.svg'),
    };

    public readonly ActivityValues: any = {
        0: 'Other',
        2: 'Assignment',
        3: 'Course',
        4: 'Elesson',
        5: 'Exam',
        6: 'Forum',
        7: 'Document',
        8: 'VirtualClass',
        9: 'Container',
        10: 'Survey',
        11: 'Video',
        12: 'MorpaActivity',
        13: 'GenericActivity',
        14: 'LinkActivity',
        15: 'DersdeoActivity',
        16: 'Dictionary',
        17: 'TelegramActivity',
        20: 'Reading',
        18: 'LTIActivity',
        19: 'Project',
        21: 'InformationNote'
    };

    public readonly ActivityColours: any = {
        0: '#000000',
        2: '#b23979',
        3: '#000000',
        4: '#8a39b2',
        5: '#3957b2',
        6: '#3992b2',
        7: '#b25d39',
        8: 'rgb(22 148 1)',
        9: '#000000',
        10: '#b2399e',
        11: '#398ab2',
        12: '#000000',
        13: '#000000',
        14: '#ebeafb',
        15: '#000000',
        16: '#000000',
        17: '#000000',
        20: '#000000',
        18: '#b29239',
        19: '#000000',
        21: '#b25d39'
    };


    public readonly DefaultLogos: any = {
        alms: require('../static/images/defaultLogos/alms/logo.svg'),
        avatar: require('../static/images/defaultLogos/avatar/egitmen_1.jpg'),
        loader: require('../static/images/defaultLogos/loader/logo.svg'),
        main: require('../static/images/defaultLogos/main/logo.svg'),
        course: require('../static/images/defaultImages/course/course.jpg'),
        smallcourse: require('../static/images/defaultImages/smallCourse/course.jpg'),
        cardImage: require('../static/images/defaultLogos/cardImage/logo.png'),
        message: require('../static/images/message.svg'),
        k365: require('../static/images/defaultLogos/k365/logo.svg'),
        playstore: require('../static/images/defaultLogos/store/playstore.png'),
        appstore: require('../static/images/defaultLogos/store/apple-black-logo.png'),
        google: require('../static/images/defaultLogos/store/google.svg'),
        apple: require('../static/images/defaultLogos/store/apple.svg')
    };
    public readonly MobileAppAnnouncement: any = {
        mobileappone: require('../static/images/mobileAppAnnouncement/mobAnn1.png'),
        mobileapptwo: require('../static/images/mobileAppAnnouncement/mobAnn2.png'),
        mobileappthree: require('../static/images/mobileAppAnnouncement/mobAnn3.png'),
        mobileappfour: require('../static/images/mobileAppAnnouncement/mobAnn4.png'),
        footerplaystore: require('../static/images/mobileAppAnnouncement/footer_playstore.png'),
        footerappstore: require('../static/images/mobileAppAnnouncement/footer_appstore.png'),
        appstore: require('../static/images/mobileAppAnnouncement/appstore.svg'),
        playstore: require('../static/images/mobileAppAnnouncement/playstore.svg'),

    };

    public InsertArrayDateDiff = (startDate: Date, endDate: Date): Date[] => {

        const arrayDiff: Date[] = [];
        const eachStartDate = new Date(startDate);
        const eachEndDate = new Date(endDate);

        while (eachEndDate > eachStartDate) {
            arrayDiff.push(eachStartDate);
            eachStartDate.setDate(eachStartDate.getDate() + 1);
        }
        if (startDate === endDate) {
            arrayDiff.push(startDate);
        }
        return arrayDiff;
    }

    public InsertAuthLocalStorage(data: IAuthInformation) {
        localStorage.setItem('access_token', data.access_token!);
        localStorage.setItem('refresh_token', data.refresh_token!);
        localStorage.setItem('expire_date', data.expire_date !== null ? data.expire_date.toString() : '');
        localStorage.setItem('auth_url', data.auth_url !== null ? data.auth_url : '');
        const worker = new Worker('/serviceWorkerEvents.js');
        worker.postMessage(data.access_token!);
    }

    public InsertRefreshingLocalStorage(bool: boolean) {
        localStorage.setItem('token_refreshing', bool.toString());
    }

    public InsertOrganizationInfosToLocalStorage(data: any) {
        localStorage.setItem('org_Abbreviation', data.OrganizationAbbreviation!);
        localStorage.setItem('org_logo', data.OrganizationLogo!);
        localStorage.setItem('googleAnalyticsCode', data.GoogleAnalyticsCode!);
    }

    public ChangeUserCulture(culture: string) {
        localStorage.setItem('currentCulture', culture);
    }

    public SetLoginLoading(loading: boolean) {
        localStorage.setItem('loginLoading', loading.toString());
    }

    public GetLoginLoading() {
        let loginLoading = false;
        if (localStorage.getItem('loginLoading') !== null) {
            loginLoading = localStorage.getItem('loginLoading') === 'true';
        }
        return loginLoading;
    }

    public GetUserCulture() {
        return localStorage.getItem('currentCulture');
    }

    public GetRefreshingLocalStorage() {
        let refreshing = false;
        if (localStorage.getItem('token_refreshing') !== null) {
            refreshing = localStorage.getItem('token_refreshing') === 'true';
        }
        return refreshing;
    }

    public HandleActivityDashboardFilter() {
        let filter: types.IFilter | null = null;
        let search = window.location.search;
        search = search.replace('?', '');
        const params = queryString.parse(search);
        let isFilter = true;
        if (params.dueDate !== undefined) {
            isFilter = false;
        }
        filter = {
            activityType: params.activityType ? Number(ActivityTypeEnums[params.activityType as any]) : null,
            completed: params.completed ? Number(params.completed) : 1,
            dueDate: params.dueDate ? Number(params.dueDate) : 1,
            grade: params.grade ? Number(params.grade) : 0,
            isDatePassed: params.isDatePassed ? Number(params.isDatePassed) : 0,
            isFiltered: isFilter
        };
        return filter;
    }

    public StringFormat = (stringData: string, values: IStringFormat[]): string => {
        values.forEach((data, index) => {
            stringData = stringData.replace('{' + data.key + '}', data.value);
        });
        return stringData;
    };

    public toStringArray(values: ISelect[], isUpdate: boolean) {
        const outputArray: string[] = [];
        if (values) {
            if (isUpdate) {
                let index = 0;
                for (index; index < values.length; index++) {
                    if (values[index].value === undefined) {
                        outputArray.push(values[index].toString());
                    } else {
                        outputArray.push(values[index].value!.toString());
                    }
                }
            } else {
                let arrayIndex = 0;
                for (arrayIndex; arrayIndex < values.length; arrayIndex++) {
                    outputArray.push(values[arrayIndex].value!.toString());
                }
            }
        }
        return outputArray;
    }

    public GetAuthLocalStorage() {
        if (localStorage.getItem('access_token') === null) {
            const AuthInf: IAuthInformation = {
                access_token: '',
                refresh_token: '',
                auth_url: '',
                expire_date: new Date()
            };
            return AuthInf;
        } else {
            const AuthInf: IAuthInformation = {
                access_token: localStorage.getItem('access_token'),
                refresh_token: localStorage.getItem('refresh_token'),
                auth_url: localStorage.getItem('auth_url'),
                expire_date: new Date(localStorage.getItem('expire_date')!)
            };
            return AuthInf;
        }
    }

    public DownloadLink(urli: string, name: string) {
        let response = fetch(urli, {
            headers: { Authorization: 'Bearer ' + this.GetAuthLocalStorage().access_token }
        })
            .then((data: any) => {
                if (data.status === 200) {
                    return data.text();
                }
            })
            .then((data1: any) => {
                const link = document.createElement('a');
                link.href = data1;
                link.setAttribute('download', name);
                link.setAttribute('_target', 'blank');
                link.target = '_blank';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            });

        return response;
    }

    public async PreviewLink(urli: string): Promise<string | null> {
        try {
            const response = await fetch(urli, {
                headers: { Authorization: 'Bearer ' + this.GetAuthLocalStorage().access_token }
            });

            if (response.status === 200) {
                const data = await response.text();
                return data;
            } else {
                return null;
            }
        } catch (error) {
            return null;
        }
    }

    public async GetImageUrl(urli: string) {
        let _data = '';
        await fetch(urli, {
            headers: { Authorization: 'Bearer ' + this.GetAuthLocalStorage().access_token }
        })
            .then((response: any) => {
                if (response.status === 200) {
                    return response.text();
                }
            })
            .then((data: any) => {
                if (data) {
                    _data = data;
                }
            });

        return _data;
    }

    public DownloadZip = (urli: string, name: string) => {
        const a = document.createElement('a');
        a.href = urli;
        a.download = '';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    };

    public ClearAuthLocalStorage() {
        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
        localStorage.removeItem('expire_date');
        localStorage.removeItem('token_refreshing');
        localStorage.removeItem('persist:almsPlusPersist');
        localStorage.removeItem('auth_url');
        localStorage.removeItem('actions_request');
        localStorage.removeItem('activeCard');

        const worker = new Worker(window.appSettings.DEFAULT_URL + 'serviceWorkerEvents.js');
        worker.postMessage('');
    }

    public GetAuthRedirect(redirectUrl: string = 'home') {
        return !!this.GetAuthLocalStorage().access_token;
    }

    public GetQuestionTypesIcons(activityType: string) {
        if (this.QuestionTypesIcons.hasOwnProperty(activityType.toLowerCase())) {
            return this.QuestionTypesIcons[activityType.toLowerCase()];
        }
        return this.QuestionTypesIcons.default;
    }
    public GetActivityIcons(activityType: string) {
        if (this.ActivityIcons.hasOwnProperty(activityType.toLowerCase())) {
            return this.ActivityIcons[activityType.toLowerCase()];
        }
        return this.ActivityIcons.default;
    }
    public GetFlagIcons(activityType: string) {
        if (this.FlagIcons.hasOwnProperty(activityType.toLowerCase())) {
            return this.FlagIcons[activityType.toLowerCase()];
        }
        return this.FlagIcons.default;
    }
    public GetActivityTypeIcons(activityType: string) {
        if (this.ActivityTypeIcons.hasOwnProperty(activityType.toLowerCase())) {
            return this.ActivityTypeIcons[activityType.toLowerCase()];
        }
        return this.ActivityTypeIcons.default;
    }


    public GetMaterialActivityIcons(activityType: ActivityType) {
        if (this.MaterialActivityIcons.hasOwnProperty(ActivityType[activityType].toLowerCase())) {
            return this.MaterialActivityIcons[ActivityType[activityType].toLowerCase()];
        }
        return this.MaterialActivityIcons.default;
    }

    public GetDefaultImages(imagesType: string) {
        if (imagesType && imagesType.length > 0 && this.DefaultImages.hasOwnProperty(imagesType.toLowerCase())) {
            return this.DefaultImages[imagesType.toLowerCase()];
        }
        return this.DefaultImages.default;
    }

    public GetDefaultIcons(iconType: string) {
        if (this.DefaultIcons.hasOwnProperty(iconType.toLowerCase())) {
            return this.DefaultIcons[iconType.toLowerCase()];
        } else {
            //
        }
        return this.DefaultIcons.default;
    }


    public GetDefaultLogos(logoType: string) {
        if (this.DefaultLogos.hasOwnProperty(logoType.toLowerCase())) {
            return this.DefaultLogos[logoType.toLowerCase()];
        } else {
            //
        }
        return this.DefaultLogos.default;
    }

    public OnErrorImageSrc = (e: any, _imgType?: string) => {
        if (e.currentTarget! && e.currentTarget!.getAttribute('data-imgtype')) {
            const imgType = e.currentTarget!.getAttribute('data-imgtype').toString();
            if (imgType) {
                e.currentTarget!.src = this.GetDefaultLogos(imgType);
            } else {
                e.currentTarget!.src = this.GetDefaultLogos('main');
            }
        } else if (_imgType) {
            e.currentTarget!.src = this.GetDefaultLogos(_imgType);
        } else {
            e.currentTarget!.src = this.GetDefaultLogos('course');
        }
    };

    public BytesToSize(bytes: number) {
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
        if (bytes === 0) return '0 Byte';
        // tslint:disable-next-line:radix
        const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)).toString());
        return Math.round(bytes / Math.pow(1024, i)) + ' ' + sizes[i];
    }

    public setPermissionMapList() {
        const main = JSON.parse(localStorage.getItem('persist:almsPlusPersist')!);
        const innerLogin = JSON.parse(main.login);

        const loginPermission = innerLogin.identitiy.loginPermission;
        const customLoginPermission = innerLogin.identitiy.customLoginPermission;
    }

    public xTimeAgo(startDate: string, nowDate: string) {
        const timeDiffirence = (Date.parse(nowDate) - Date.parse(startDate)) / 1000;
        const second = timeDiffirence;
        const minute = Math.round(timeDiffirence / 60);
        const hour = Math.round(timeDiffirence / 3600);
        const day = Math.round(timeDiffirence / 86400);
        const week = Math.round(timeDiffirence / 604800);
        const month = Math.round(timeDiffirence / 2419200);
        const year = Math.round(timeDiffirence / 29030400);
        if (second < 60) {
            if (second === 0) {
                return T.t('r_xtime_ago_just');
            } else {
                return second + T.t('r_xtime_ago_second');
            }
        } else if (minute < 60) {
            return minute + ' ' + T.t('r_xtime_ago_minute');
        } else if (hour < 24) {
            return hour + ' ' + T.t('r_xtime_ago_hour');
        } else if (day < 7) {
            return day + ' ' + T.t('r_xtime_ago_day');
        } else if (week < 4) {
            return week + ' ' + T.t('r_xtime_ago_week');
        } else if (month < 12) {
            return month + ' ' + T.t('r_xtime_ago_month');
        } else {
            return year + ' ' + T.t('r_xtime_ago_year');
        }
    }

    public GetMonthText(month: number): string {
        const setMonth = new Array();
        setMonth[0] = 'r_month_January';
        setMonth[1] = 'r_month_February';
        setMonth[2] = 'r_month_March';
        setMonth[3] = 'r_month_April';
        setMonth[4] = 'r_month_May';
        setMonth[5] = 'r_month_June';
        setMonth[6] = 'r_month_July';
        setMonth[7] = 'r_month_August';
        setMonth[8] = 'r_month_September';
        setMonth[9] = 'r_month_October';
        setMonth[10] = 'r_month_November';
        setMonth[11] = 'r_month_December';
        return setMonth[month];
    }

    findDateFormat(userPreferences: IPreference[] | null | undefined, isWithTimeFormat?: boolean) {
        if (userPreferences && userPreferences.length > 0) {
            const userPrefrences = (userPreferences.find(pref => pref.name === 'application.dateformat') as IPreference);
            if (userPrefrences) {
                return (userPreferences.find(pref => pref.name === 'application.dateformat') as IPreference).value + (isWithTimeFormat ? (' ' + window.appSettings.DefaultDateTimeFormat) : '');
            }
        }
        return window.appSettings.DefaultDateFormat + (isWithTimeFormat ? (' ' + window.appSettings.DefaultDateTimeFormat) : '');
    }

    public GetDateFormatFromPrefrences(userPreferences: IPreference[] | null, type?: number) {
        let dateFormat = this.findDateFormat(userPreferences);
        if (type) {
            switch (type) {
                case 1:
                    dateFormat = dateFormat === window.appSettings.DefaultDateFormat ? 'DD-MM-YYYY' : 'MM-DD-YYYY';
                    break;
                case 2:
                    dateFormat = dateFormat === window.appSettings.DefaultDateFormat ? 'LLLL' : 'DD MMM dddd YYYY HH:mm';
                    break;
                case 3:
                    dateFormat = dateFormat === window.appSettings.DefaultDateFormat ? 'HH:mm / DD.MM.YYYY' : 'HH:mm / MM.DD.YYYY';
                    break;
                default:
                    break;
            }
        }
        return dateFormat;
    }

    public isDateRangeValid(startDate: Date, endDate: Date, dateRangeInput: string, type: number, dateFormat?: string) {
        const selectedDateFormat = dateFormat ? dateFormat : window.appSettings.DefaultDateFormat;
        const startDateInput = Moment(dateRangeInput.substring(0, 10), selectedDateFormat).toDate();
        const endDateInput = (dateRangeInput.length > 13 ? Moment(dateRangeInput.substring(13, dateRangeInput.length), selectedDateFormat).endOf('day').toDate() : Moment(dateRangeInput, selectedDateFormat).toDate());
        const _startDate = (type === 3 ? Moment(startDate, selectedDateFormat).toDate() : Moment(startDate).startOf('day').toDate());
        const _endDate = (type === 3 ? Moment(endDate, selectedDateFormat).toDate() : Moment(endDate).endOf('day').toDate());

        if (type === 1 && endDateInput <= _endDate && startDateInput >= _startDate) {

            return true;
        }
        if (type === 2 && startDateInput > _startDate && endDateInput < _endDate) {
            return true;
        }
        if (type === 3 && startDateInput <= _startDate && endDateInput > _endDate) {
            return true;
        }
        return false;
    }

    public isTaskDeadLineDateInWeeks(termWeeks: ICourseContentTermWeeks[] | null | undefined, termWeekIds: any, dateValue: string, dateFormat?: string, isRetunDate?: boolean) {
        let minStartDate: Date | null = null;
        let maxEndDate: Date | null = null;
        const isTypeObject = termWeekIds && termWeekIds.length > 0 ? (typeof termWeekIds[0] === 'object' ? true : false) : false;
        if (termWeeks && termWeekIds) {
            termWeekIds.forEach((item: any) => {
                const weekDates = termWeeks.filter(weeks => weeks.termWeekId === (isTypeObject ? item.value : item));
                if (weekDates && weekDates.length > 0 && weekDates[0].startDate && weekDates[0].endDate) {
                    minStartDate = minStartDate ? (weekDates[0].startDate < minStartDate ? weekDates[0].startDate : minStartDate) : weekDates[0].startDate;
                    maxEndDate = maxEndDate ? (weekDates[0].endDate > maxEndDate ? weekDates[0].endDate : maxEndDate) : weekDates[0].endDate;
                }
            });
        }
        if (isRetunDate) {
            return maxEndDate;
        }
        if (minStartDate && maxEndDate) {
            return this.isDateRangeValid(minStartDate, maxEndDate, dateValue, 1, dateFormat);
        }
        return true;
    }

    public dateConvertToString(date?: Date | null, dateFormat?: string) {
        if (date) {
            return Moment(date).format(dateFormat ? dateFormat : window.appSettings.DefaultDateFormat).toString();
        }
        return '';
    }

    public findTermWeekIdForRefreshPage(props: any, value: any) {
        let termWeekId = value.termWeekId;
        if (!termWeekId) {
            termWeekId = props.initialTermWeekId;
        }
        if (value.submitValues.dateCriteria === DateCriteria.timeInterval && props.courseContentTermWeeks) {
            const isInTermWeek = props.courseContentTermWeeks
                .filter((termWeek: any) => termWeek.startDate && (Moment(termWeek.startDate).toDate() < Moment(value.submitValues.activityConditionalBeginDate).toDate()) &&
                    termWeek.endDate && (Moment(termWeek.endDate).toDate() > Moment(value.submitValues.activityConditionalBeginDate).toDate()));
            termWeekId = isInTermWeek && isInTermWeek.length > 0 ? isInTermWeek[0].termWeekId : props.initialTermWeekId;
        }

        if (value.submitValues.dateCriteria === DateCriteria.prerequisiteActivity) {
            termWeekId = '0'
        }
        return termWeekId;
    }

    public areArraysEqual(prevArray: string[], currentArray: string[]): boolean {
        if (prevArray.length !== currentArray.length) {
            return false;
        }

        const sortedPrevArray = [...prevArray].sort();
        const sortedCurrentArray = [...currentArray].sort();

        return sortedPrevArray.every((value, index) => value === sortedCurrentArray[index]);
    }

    public getVideoType(fileEmbedUrl: string | null) {
        if (fileEmbedUrl) {
            if (fileEmbedUrl.includes('youtube')) {
                return VideoType.Youtube;
            } else if (fileEmbedUrl.includes('vimeo')) {
                return VideoType.Vimeo;
            }
        }
        return VideoType.OtherEmbedded;
    }

    public ConvertVideoTestLogViewData = (viewData: string) => {
        const clearViewDataArray = this.ClearConvertVideTestLogViewData(viewData).split(',');
        viewData = '[' + clearViewDataArray + ']';
        return viewData;
    }

    public getSeekTime = (value: string | null | undefined): number | null => {
        let values = [];
        const re1 = /\,/gi;
        if (value) {
            value = this.ClearConvertVideTestLogViewData(value).replace(re1, '-');
            values = value.split('-');
            if (values && values.length > 0) {

                const b = value.split('-').map(x => +x);

                return Math.max(...b); // Number.parseFloat(values[0]);
            } else return 0;
        } else return 0;
    }

    public GetMobileAppAnnouncement(imagesType: string) {
        if (imagesType && imagesType.length > 0 && this.MobileAppAnnouncement.hasOwnProperty(imagesType.toLowerCase())) {
            return this.MobileAppAnnouncement[imagesType.toLowerCase()];
        }
        return this.MobileAppAnnouncement.default;
    }

    public ClearConvertVideTestLogViewData = (viewData: string) => {
        const re1 = /\[/gi;
        const re2 = /\]/gi;
        const re3 = /\_/gi;
        const re4 = /\"/gi;
        const re5 = /\\/gi;
        const clearViewData = viewData.replace(re1, '').replace(re2, '').replace(re3, '').replace(re4, '').replace(re5, '');

        return clearViewData;
    }

    public isArabic = (text?: string, direction?: string | null) => {

        if (direction) {
            if (direction == 'ltr') {
                return true;
            }
        }
        else {
            return true;
        }

        if (text) {
            let textConvert: any = text.replace(/<[^>]*>?/gm, '');
            if (textConvert) {
                let languageText = lngDetector.detect(textConvert, 1);
                if (languageText[0]) {
                    if (languageText[0][0] == 'arabic') {
                        return true
                    }
                }
            }
        }


        return false;
    }

    public removeHtmlTags = (text?: string, npspStatus?: boolean) => {
        if (text == undefined) {
            return '';
        }
        const regex = /(<([^>]+)>)/gi;
        let result = text.replace(regex, "");

        if (npspStatus === true) {
            result = result.replace(/\s/g, '')
            result = result.replace(/&nbsp;/g, '');
        }

        return result;

    }

    public storeLinks(culture: string, store: number) {

        let androidStoreLink = 'https://play.google.com/store/apps/details?id=com.advancity.alms&gl=TR&pli=1';
        let appleStoreLink = 'https://apps.apple.com/tr/app/k365/id1606171662?l=tr';

        if (culture == 'en-US' || culture == 'en') {
            androidStoreLink = 'https://play.google.com/store/search?q=K365&c=apps';
            appleStoreLink = 'https://apps.apple.com/tr/app/k365/id1606171662?l=en';
        }
        else if (culture == 'ar-SA' || culture == 'ar') {
            androidStoreLink = 'https://play.google.com/store/apps/details?id=com.advancity.alms';
            appleStoreLink = 'https://apps.apple.com/tr/app/k365/id1606171662?l=ar';
        }

        if (store == 1) {
            return androidStoreLink;
        }
        else {
            return appleStoreLink;
        }


    }
}
